export default "__VITE_ASSET__Bm8IH0qd__"